<template>
  <LayoutController>
    <div :class="['App', { 'sidebar--closed': !isSidebarOpen }, { 'sidebar--none': !is_sidebar }]">
      <Icon />
      <!-- <div v-if="false && is_sidebar && main_message.message" class="Header_message el-alert--danger is-dark dynamic-height">
        <span v-html="main_message.message + ' '" />
        <RouterLink v-if="main_message.route" :to="{ name: main_message.route }">
          <span>Check details now</span>
        </RouterLink>
      </div> -->

      <!-- app header -->
      <AppHeader
        :is-sidebar="is_sidebar"
        class="Header dynamic-height text-grayDark bg-gray-50 border border-gray-200 flex justify-flex-start items-center w-full fixed"
        :class="[{ 'Header--no_toggle': !is_sidebar }]"
      />

      <!-- app sidebar -->
      <AppSidebar v-if="is_sidebar" class="Sidebar" :class="is_mainmessage ? 'line_message' : ''" />

      <!-- main content wrapper -->
      <div class="Main" :class="is_mainmessage ? 'line_message' : ''">
        <!-- breadcrumbs -->
        <Breadcrumbs v-if="is_breadcrumbs" ref="childComponent" />

        <!-- inline alerts -->
        <ElAlert
          v-if="global_message.message"
          :title="global_message.title"
          :type="global_message['message-type']"
          :description="global_message.message"
          show-icon
          :closable="false"
          class="Page__alert"
        />

        <!-- route view placeholder -->
        <RouterView v-loading-pld="isLoading" class="Content clearfix" />
      </div>
    </div>
  </LayoutController>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { LoadingPld } from '@/directives'
// import { startWS, leaveWS } from '@/plugins/websockets'
import Icon from '@/components/icons'
import LayoutController from '@/components/parts/LayoutController'

import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Switch,
  Select,
  Option,
  Menu,
  Submenu,
  MenuItemGroup,
  MenuItem,
  Card,
  Pagination,
  Badge,
  Popover,
  Scrollbar,
  Tabs,
  TabPane,
  Steps,
  Step,
  Dialog,
} from 'element-ui'

Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Switch)
Vue.use(Select)
Vue.use(Option)

Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(MenuItem)

Vue.use(Popover)
Vue.use(Card)
Vue.use(Pagination)
Vue.use(Badge)
Vue.use(Scrollbar)
Vue.use(Steps)
Vue.use(Step)

Vue.use(Tabs)
Vue.use(TabPane)

Vue.use(LoadingPld)

Vue.use(Dialog)

// layout components
const AppSidebar = () => import(/* webpackChunkName: "_c-sidebar" */ '@/components/sidebar/Sidebar')
const AppHeader = () => import(/* webpackChunkName: "_c-header" */ '@/components/header/Header')
const Breadcrumbs = () => import(/* webpackChunkName: "_c-breadcrumbs" */ '@/components/parts/Breadcrumbs')

// global components
const CountBar = () => import(/* webpackChunkName: "_c-countbar" */ '@/components/parts/CountBar')
Vue.component('CountBar', CountBar)

export default {
  name: 'AppLayout',

  metaInfo() {
    return {
      bodyAttrs: {
        class: this.is_CreativeStudio
          ? ['app', this.is_CreativeStudioDarkBg ? 'creativeStudio creativeStudioDark' : 'creativeStudio']
          : 'app',
      },
    }
  },

  components: {
    AppSidebar,
    AppHeader,
    Breadcrumbs,
    Icon,
    LayoutController,
  },

  computed: {
    ...mapGetters({
      global_message: 'user/global_message',
      main_message: 'user/main_message',
      isLoading: 'app/is_loading',
      isSidebarOpen: 'app/is_sidebar_open',
    }),

    is_mainmessage() {
      if (this.main_message.message) {
        return true
      } else {
        return false
      }
    },

    is_subscription() {
      return this.$route.name === 'subscription'
    },

    is_suspended() {
      return this.$route.name === 'suspended'
    },

    is_dashboard() {
      return this.$route.name === 'dashboard-child'
    },

    is_dashboard_CS() {
      return this.$route.name === 'creative-studio'
    },

    is_CreativeStudio() {
      return this.$route.name.startsWith('creative-studio')
    },

    is_CreativeStudioDarkBg() {
      return ['creative-studio'].includes(this.$route.name)
    },

    is_not_found() {
      return this.$route.name === 'NotFound'
    },

    is_breadcrumbs() {
      return !Boolean(this.is_dashboard || this.is_not_found || this.is_subscription || this.is_suspended || this.is_campaign).valueOf()
    },

    is_sidebar() {
      return !Boolean(this.is_subscription || this.is_suspended).valueOf()
    },

    is_campaign() {
      const regex = /(^|\/)campaign[^/]*(\/|$)/
      return regex.test(this.$route.name)
    },
  },

  mounted() {
    // const user_ID = this.$store.state.user.id

    // init websockets
    // if (user_ID) {
    //   startWS(user_ID)
    // }

    // append JIRA feedback script
    if (process.env.VUE_APP_JIRA_SCRIPT_ENABLED === 'true') {
      const jiraScript = document.createElement('script')
      jiraScript.setAttribute(
        'src',
        'https://productlead.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/1jmxwi/b/8/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=dc123ee3'
      )
      document.head.appendChild(jiraScript)
    }

    // append Profitwell script
    if (process.env.VUE_APP_PROFITWELL_SCRIPT_ENABLED === 'true') {
      const profitwellScript = document.createElement('script')
      profitwellScript.setAttribute('id', 'profitwell-js')
      profitwellScript.setAttribute('data-pw-auth', 'fc6784d04b382bbf52121aef064d63e1')
      profitwellScript.innerHTML =
        "(function(i,s,o,g,r,a,m){i[o]=i[o]||function(){(i[o].q=i[o].q||[]).push(arguments)};a=s.createElement(g);m=s.getElementsByTagName(g)[0];a.async=1;a.src=r+'?auth='+s.getElementById(o+'-js').getAttribute('data-pw-auth');m.parentNode.insertBefore(a,m);})(window,document,'profitwell','script','https://public.profitwell.com/js/profitwell.js');"
      document.head.appendChild(profitwellScript)
    }
  },

  beforeDestroy() {
    // const user_ID = this.$store.state.user.id
    // leaveWS(user_ID)
  },
}
</script>

<style lang="scss">
@import '@/assets/fonts/ibm-plex-sans.scss';
@import '@/assets/sass/layouts/_app.scss';
@import '@/assets/sass/_main.scss';
</style>
